import {
  createTabFilAriane, getLibelleEtatDevisCommandeFacture,
  updateObjectFilAriane,
  setInfoDevisWithCommandeOrAcompte,
  setInfoFactureWithCommande,
} from '@/services/dcf/detail/filAriane/utilsFunctionsFilAriane';
import { DEVIS_COMMANDE_ETAT, ETAT_SANSSUITE } from '@/configuration/devisConf';

export default async function createFilArianeCommande(commande, isVenteInterne, signatureInfo) {
  const tabFilAriane = createTabFilAriane();
  const customClassMarker = commande.etat === ETAT_SANSSUITE ? 'is-danger has-text-danger' : null;
  const icon = commande.etat === ETAT_SANSSUITE ? 'close-thick' : null;
  updateObjectFilAriane(tabFilAriane[1], tabFilAriane[1].libelle, null, null,
    true, customClassMarker,
    getLibelleEtatDevisCommandeFacture(commande.etat, DEVIS_COMMANDE_ETAT),
    icon, null, null, signatureInfo);
  await setInfoDevisWithCommandeOrAcompte(commande, tabFilAriane);
  await setInfoFactureWithCommande(commande, tabFilAriane, isVenteInterne);
  return tabFilAriane;
}
